import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'
import { postCheckAccount } from '../../api/login'

export default function PhoneChange({ setChangeEmail, setChangePhone, setText }: any) {
  const [email, setEmail] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [emailCheck, setEmailCheck] = useState<boolean>(false)
  const [phoneCheck, setPhoneCheck] = useState<boolean>(false)
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  // 이메일 검증 함수
  function validateEmail(email: string) {
    return setEmailCheck(emailPattern.test(email))
  }
  function validatePhoneNumber(number: any) {
    const phonePattern = /^(01[016789])-?\d{4}-?\d{4}$/
    console.log(phonePattern.test(number))
    if (phonePattern.test(number)) {
      setPhoneCheck(true)
      return true
    } else {
      setPhoneCheck(false)
      return false
    }
  }
  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <>
      <PageTitle className='small' style={{ padding: '0 20px 12px' }}>
        <span style={{ color: '#0041FF' }}>가입 시 입력했던 정보</span>를
        <br />
        입력해주세요.
        <span
          style={{
            display: 'block',
            marginTop: '8px',
            fontSize: '14px',
            lineHeight: '20px',
            color: 'var(--colBlack)',
            fontWeight: '500',
          }}
        >
          회원님의 정보를 찾도록 도와드릴게요.
        </span>
        {/* <span style={{display:'block', marginTop:'8px', fontSize:'14px', lineHeight:'20px', color:'var(--colBlack)', fontWeight:'500'}}>변경할 휴대폰번호를 인증해주세요.</span> */}
      </PageTitle>

      <div className='profile_wrap'>
        <div className='profile_info'>
          <div className='inp_box'>
            <p>이메일주소</p>
            <input
              type='text'
              placeholder='이메일을 입력해주세요.'
              onChange={(e) => {
                setEmail(e.target.value)
                setChangeEmail(e.target.value)
                validateEmail(email)
              }}
            />
          </div>
          <div className='inp_box'>
            <p>이전 휴대폰 번호</p>
            <input
              type='text'
              placeholder='휴대폰번호'
              pattern='[0-9]*'
              inputMode='numeric'
              value={phone} // controlled input으로 만들어 줍니다
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 11)
                setPhone(value)
                setChangePhone(value)
                validatePhoneNumber(value)
              }}
              style={{ outline: 'none' }}
              maxLength={11}
            />
          </div>
        </div>
        <div
          style={{
            width: '237px',
            margin: '0 auto',
          }}
        >
          <button
            type='button'
            className='btn_save'
            style={{
              borderRadius: '100px',
              background: emailCheck && phoneCheck ? 'var(--colBlack)' : 'var(--colGray2)',
              color: emailCheck && phoneCheck ? 'var(--colWhite)' : 'var(--colGray4)',
            }}
            onClick={() => {
              if (emailCheck && phoneCheck) {
                postCheckAccount(phone, email).then((res) => {
                  if (res.data.message === 'ok') {
                    setText('phonemodify')
                  } else {
                    alert('휴대폰번호 또는 이메일을 확인해주세요')
                  }
                })
                //
              }
            }}
          >
            확인
          </button>
        </div>
      </div>
    </>
  )
}
